import { render, staticRenderFns } from "./Leakageratetemplate.vue?vue&type=template&id=1410ad96&scoped=true"
import script from "./Leakageratetemplate.vue?vue&type=script&lang=js"
export * from "./Leakageratetemplate.vue?vue&type=script&lang=js"
import style0 from "./Leakageratetemplate.vue?vue&type=style&index=0&id=1410ad96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410ad96",
  null
  
)

export default component.exports